import type { LucideIcon } from 'lucide-react';
import { Briefcase, FileMinus, FileText, Receipt, Target, User } from 'lucide-react';

export type SearchKind = 'contact' | 'job' | 'invoice' | 'estimate' | 'creditMemo' | 'lead';

export interface SearchGroupDefinition {
  id: SearchKind;
  heading: string;
  icon: LucideIcon;
  requiredPermission: string;
}

export const SEARCH_GROUPS: SearchGroupDefinition[] = [
  { id: 'contact', heading: 'Contacts', icon: User, requiredPermission: 'contacts:view' },
  { id: 'job', heading: 'Jobs', icon: Briefcase, requiredPermission: 'jobs:view' },
  { id: 'invoice', heading: 'Invoices', icon: Receipt, requiredPermission: 'invoices:view' },
  { id: 'estimate', heading: 'Estimates', icon: FileText, requiredPermission: 'estimates:view' },
  {
    id: 'creditMemo',
    heading: 'Credit memos',
    icon: FileMinus,
    requiredPermission: 'invoices:view',
  },
  { id: 'lead', heading: 'Leads', icon: Target, requiredPermission: 'leads:view' },
];

export function getPermittedSearchKinds(permissions: string[]): SearchKind[] {
  return SEARCH_GROUPS.filter((group) => permissions.includes(group.requiredPermission)).map(
    (group) => group.id,
  );
}
